import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ProductTypeService } from '../../services/product-type.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    if (oid == 0) {
        record.set({ oid: 0 });
    }
    else {
        let _resp = await ProductTypeService.fetchProductType(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ProductTypeService.getProductTypes(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    //navigate(`/product-type/0`);
}
export function onEdit(item) {
    navigate(`/product-type/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await ProductTypeService.saveProductType(_record);
}
export async function onDelete(item) {
    //await ProductTypeService.deleteProductType(item.oid);
    //await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
